module.exports = __webpack_public_path__ + "static/media/coffee-pot.40b8febd.svg";